module.exports = __webpack_public_path__ + "img/31.10.pH.98f78e3a.png";